import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

import { DESKTOP_MIN_WIDTH } from "~/feature/getUpdates/constants";

const PILL_BOTTOM_OFFSET = 82;
const CALCULATOR_DOCK_PILL_BOTTOM_OFFSET = 190;

export const Pill = styled(Button, {
  shouldForwardProp: (prop) => prop !== "$raised",
})<{ $raised: boolean }>(({ theme, $raised }) => {
  const isDark = theme.palette.mode === "dark";

  return {
    display: "none",

    [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
      display: "inline-flex",
      position: "fixed",
      bottom: $raised ? CALCULATOR_DOCK_PILL_BOTTOM_OFFSET : PILL_BOTTOM_OFFSET,
      left: "50%",
      transform: "translateX(-50%)",
      zIndex: 1150,
      height: 44,
      padding: theme.spacing(0, 2.5),
      borderRadius: 999,
      textTransform: "none",
      fontSize: 15,
      fontWeight: 600,
      letterSpacing: "-0.1px",
      whiteSpace: "nowrap",
      boxShadow: "0 8px 28px rgba(11, 12, 14, 0.24)",
      backgroundColor: isDark ? theme.palette.common.white : "#111111",
      color: isDark ? "#111111" : theme.palette.common.white,

      "&:hover": {
        backgroundColor: isDark ? theme.palette.grey[300] : "#2A2E35",
      },

      "& .MuiButton-startIcon svg": {
        width: 20,
        height: 20,
      },
    },
  };
});
